import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { useState, useEffect } from "react";
import { COMPANY } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import LanguageSwitcher from "@/components/LanguageSwitcher";

const links = [
  { to: "/", label: "Home" },
  { to: "/properties", label: "Properties" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/submit-property", label: "List Property" },
  { to: "/blog", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled ? "bg-brand-ivory/95 backdrop-blur-md shadow-sm border-b border-brand-gold/20" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={COMPANY.logo} alt="Wilshire" className="h-12 w-12 object-contain rounded-sm" />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-xl text-brand-navy tracking-wide">WILSHIRE</span>
            <span className="text-[10px] tracking-[0.35em] text-brand-gold uppercase">Buildcon Co.</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide font-medium transition-colors ${
                  isActive ? "text-brand-gold" : "text-brand-navy hover:text-brand-gold"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <LanguageSwitcher />
          <a href={`tel:${COMPANY.phone}`} data-testid="nav-call-btn" className="flex items-center gap-2 text-brand-navy text-sm">
            <Phone size={14} className="text-brand-gold" />
            <span className="font-medium">{COMPANY.phone}</span>
          </a>
        </div>

        <button
          className="lg:hidden text-brand-navy"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-brand-ivory border-t border-brand-gold/20 px-6 py-6 space-y-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="block text-brand-navy hover:text-brand-gold font-medium"
            >
              {l.label}
            </NavLink>
          ))}
          <a href={`tel:${COMPANY.phone}`} className="block text-brand-gold font-medium">{COMPANY.phone}</a>
        </div>
      )}
    </header>
  );
}
